module.exports = __webpack_public_path__ + "static/media/dark.414f10de.png";